import React, { useContext } from "react";
import { matchPath, useLocation } from "react-router-dom";
import { UNAUTHORIZED_ROUTES_MAPPING } from "../../routes"
import { UserContext } from "../../Context";
import { AccessDenied } from "../Common";

const UnAuthorizedRoute = ({ children }) => {
  const location = useLocation();
  const { user } = useContext(UserContext);

  const userRole = user?.role?.toUpperCase();
  const unauthorizedRoutes = UNAUTHORIZED_ROUTES_MAPPING[userRole] || [];

  const isUnauthorized = unauthorizedRoutes.some((route) =>
    matchPath({ path: route, end: false }, location.pathname)
  );

  if (isUnauthorized) {
    return <AccessDenied />;
  }

  return children;
};

export default UnAuthorizedRoute;
